import { Form, Head, router, usePage } from "@inertiajs/react"
import { FcGoogle } from "react-icons/fc"

import InputError from "@/components/input-error"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Separator } from "@/components/ui/separator"
import AuthLayout from "@/layouts/auth-layout"
import { signInPath, signUpPath } from "@/routes"

export default function Register() {
  const { props } = usePage()
  // eslint-disable-next-line react/prop-types
  const isMobileApp = (props.app as { mobile_app?: boolean })?.mobile_app

  const handleGoogleLogin = async () => {
    if (isMobileApp) {
      const { handleNativeGoogleLogin } = await import("@/lib/native-auth")
      await handleNativeGoogleLogin()
    } else {
      window.location.assign("/auth/google")
    }
  }
  return (
    <AuthLayout
      title="Crear una cuenta"
      description="Ingresa tus datos para crear tu cuenta"
    >
      <Head title="Registro" />
      <Form
        method="post"
        action={signUpPath()}
        resetOnSuccess={["password", "password_confirmation"]}
        disableWhileProcessing
        className="flex flex-col gap-6"
      >
        {({ processing, errors }) => (
          <>
            <div className="grid gap-6">
              <div className="grid gap-2">
                <Label htmlFor="name">Nombre</Label>
                <Input
                  id="name"
                  type="text"
                  name="name"
                  required
                  tabIndex={1}
                  autoComplete="name"
                  disabled={processing}
                  placeholder="Nombre completo"
                />
                <InputError message={errors.name} className="mt-2" />
              </div>

              <div className="grid gap-2">
                <Label htmlFor="email">Correo electrónico</Label>
                <Input
                  id="email"
                  type="email"
                  name="email"
                  required
                  tabIndex={2}
                  autoComplete="email"
                  placeholder="correo@ejemplo.com"
                />
                <InputError message={errors.email} />
              </div>

              <div className="grid gap-2">
                <Label htmlFor="password">Contraseña</Label>
                <Input
                  id="password"
                  type="password"
                  name="password"
                  required
                  tabIndex={3}
                  autoComplete="new-password"
                  placeholder="Contraseña"
                />
                <InputError message={errors.password} />
              </div>

              <div className="grid gap-2">
                <Label htmlFor="password_confirmation">
                  Confirmar contraseña
                </Label>
                <Input
                  id="password_confirmation"
                  type="password"
                  name="password_confirmation"
                  required
                  tabIndex={4}
                  autoComplete="new-password"
                  placeholder="Confirmar contraseña"
                />
                <InputError message={errors.password_confirmation} />
              </div>
              <Button
                type="submit"
                className="mt-[6px] mb-[11px] h-[49px] w-full rounded-[14px] px-[24px] py-[14px] text-[15px] leading-[23px] font-medium tracking-[0.45px]"
                disabled={processing}
              >
                {processing ? "Creando cuenta..." : "Crear Cuenta"}
              </Button>
            </div>

            <div className="space-y-4">
              <Separator />
              <Button
                type="button"
                variant="default"
                disabled={processing}
                className="my-[17px] h-[49px] w-full rounded-[14px] text-[15px] leading-[23px] font-medium tracking-[0.45px] text-white"
                onClick={() => {
                  void handleGoogleLogin()
                }}
              >
                <div className="bg-card mr-2 flex h-[32px] w-[32px] items-center justify-center rounded-full">
                  <FcGoogle className="size-7" />
                </div>
                Registrarse con Google
              </Button>

              <div className="text-chart-5 text-center text-[13px] leading-[20px] font-normal tracking-[0.2px]">
                ¿Ya tienes cuenta?{" "}
                <button
                  type="button"
                  onClick={() => {
                    router.visit(signInPath())
                  }}
                  className="text-chart-3 text-center text-[12px] leading-[18px] font-medium tracking-[0.18px]"
                >
                  Iniciar sesión
                </button>
              </div>
            </div>
          </>
        )}
      </Form>
    </AuthLayout>
  )
}
